import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.component.html',
  providers: []
})

export class ContractsComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/contracts.component.ts